// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"14ba37ca","509":"beb70831","652":"b21212f8"}[chunkId] + ".chunk.js";
};